import EvaluationStats from "./evaluationStats.view";

export default EvaluationStats;
